import React from 'react'
import PropTypes from 'prop-types'
import DropdownField from '../../FormComponents/DropdownField/DropdownField'
import SwitchButton from '../../FormComponents/SwitchButton/Switch'
import StateProgressBlock from '../../StatesProgress/StatesProgress'
import { page as pageIndex } from '../../../globals'

class ComplianceAlerts extends React.PureComponent {
  returnSubjectRows = () => {
    const { trackData, updateData, type } = this.props
    return subjects.map((item, i) => {
      const className = trackData[type].radio[item.id]
        ? 'alert-row-subj'
        : 'alert-row-subj grey-alert-rows'
      if (!trackData[type].radio[item.id]) {
        trackData[type].radio[item.id] = false
      }
      return <div key={i} className={className}>
        <div className="alerts-col alert-sub allow-click">
          <SwitchButton
            text="Subscribed"
            location={{ page: pageIndex.dashboard, field: [type] }}
            id={item.id}
            isEnabled={trackData[type].radio[item.id]}
            updateData={updateData}
          />
        </div>
        <div className="alerts-col alert-sub alert-name">{item.name}</div>
        <div className="alerts-col alert-sub">
          <StateProgressBlock
            page="D"
            field="states"
            values={trackData[type].states}
            updateData={updateData}
            fieldData={[]}
          />
        </div>
        <div className="alerts-col alert-sub">
          <DropdownField
            id="alertType"
            location={{ page: pageIndex.dashboard, field: type }}
            options={options}
            defaultValue="weeklyQuarterly"
            value={trackData[type].radio.alertType}
            updateData={updateData}
          />
        </div>
      </div>
    })
  }

  returnTitle = () => {
    const { type } = this.props
    let title
    let subTitle
    switch (type) {
      case 'legisComplianceAlerts':
        title = 'Legislative'
        subTitle = 'legislation'
        break
      case 'regsComplianceAlerts':
        title = 'Regulatory'
        subTitle = 'regulations'
        break
    }
    return { title, subTitle }
  }

  render () {
    const { title, subTitle } = this.returnTitle()
    return <div className="alert-category-body custom-scroll">
      <div className="category-alerts-title">{title} Alerts by Category</div>
      <div className="category-alerts-subtitle">Setup or modify e-mail alerts for {subTitle} by subject and state</div>
      <div className="rows-wrapper">
        <div className="alert-title-wrapper">
          {titles.map((item, i) => <div key={i} className="alerts-col title">{item}</div>)}
        </div>
        {this.returnSubjectRows()}
      </div>
    </div>
  }

  static propTypes = {
    trackData: PropTypes.object,
    updateData: PropTypes.func,
    type: PropTypes.string
  }
}

export default ComplianceAlerts

const titles = ['Subscribe', 'Subject', 'State', 'Alert Frequency']
const subjects = [
  {
    name: 'All subjects',
    states: [],
    alertType: true,
    id: 'sub1'
  },
  {
    name: 'sample subject 1',
    states: [],
    alertType: false,
    id: 'sub2'
  }
]
const options = [
  { value: 'dailyQuarterly', label: 'Daily Alerts + Quarterly Summary' },
  { value: 'dailyOnly', label: 'Daily Alerts Only' },
  { value: 'weeklyQuarterly', label: 'Weekly Alerts + Quarterly Summary' },
  { value: 'weeklyOnly', label: 'Weekly Alerts Only' }
]



// WEBPACK FOOTER //
// ./src/components/ManagementEmailAlerts/components/ComplianceAlerts.js